// moz667: por culpa de vrdemo
var $ = jQuery;

window.init_one2one_request_form = function () {
    var $submit_form = $('form.one2one-request-form .main-form-buttons button[type="submit"]');
    var is_modify_request = $("#id_modify_request").val() != "";

    // hover de request_type
    $(".wrap-121-request-type .btn").each(function () {
        var $this = $(this);

        if ($this.hasClass("active")) {
            $this.find("img").attr("src", $this.data("on"));
        }

        if (!is_modify_request) {
            $this.on("mouseover", function () {
                $this.find("img").attr("src", $this.data("on"));
            }).on("mouseout", function () {
                if (!$this.hasClass("active")) {
                    $this.find("img").attr("src", $this.data("off"));
                }
            }).on("click", function () {
                $(".wrap-121-request-type .btn").each(function () {
                    var $btn = $(this);
                    $btn.find("img").attr("src", $btn.data("off"));
                });

                $this.find("img").attr("src", $this.data("on"));
            }).on("change", function () {
                $(".clear-autocomplete").click();
                $submit_form.prop('disabled', true);
            });
        }
    });

    if (!is_modify_request) {
        init_autocomplete("organization_filter", function (data) {
            // console.log(data);
        });

        init_autocomplete("organization_contact_filter", function (data) {
            var suggestion = data.suggestion;
            // console.log(suggestion);

            var $org_fields = get_a10e_fields("organization_filter");

            if (suggestion.organization) {
                $org_fields["data_input"].val(suggestion.organization);
                $org_fields["query_input"].val(suggestion.organization).prop('disabled', false).prop('readonly', true);
                $org_fields["clear_button"].prop('disabled', false);
            } else {
                $org_fields["data_input"].val("");
                $org_fields["query_input"].val("").prop('disabled', true);
                $org_fields["clear_button"].prop('disabled', true);
            }

            populate_available_dates();
        }, function () {
            var $org_fields = get_a10e_fields("organization_filter");
            $org_fields["query_input"].prop('disabled', false).prop('readonly', false);
            disable_date_field();
            disable_time_field();
            $submit_form.prop('disabled', true);
        });

        if ($("#organization_contact_filter").val() && !$("#organization_filter").val()) {
            var $org_fields = get_a10e_fields("organization_filter");
            $org_fields["query_input"].val("").prop('disabled', true);
        }
    } else {
        // $(".autocomplete-group-append").hide();
        $(".autocomplete-query").prop('disabled', false).prop('readonly', true);
        $(".clear-autocomplete").prop('disabled', true);
        $(".wrap-121-request-type input").prop('disabled', true);
    }

    $submit_form.prop('disabled', true);

    if (!$("#organization_contact_filter").val()) {
        disable_date_field();
        disable_time_field();
    } else {
        populate_available_dates();
    }

    if ($("#id_request_time").val() != "") {
        $submit_form.prop('disabled', false);
    }

    function disable_date_field() {
        $("#id_request_date").hide();
        // TODO: i18n
        // $("#id_request_date").html('<option value="">Seleccione contacto</option>').prop('disabled', true);
    }

    function disable_time_field() {
        $("#id_request_time").hide();
        // TODO: i18n
        // $("#id_request_time").html('<option value="">Seleccione contacto y fecha</option>').prop('disabled', true);
    }

    function populate_available_times() {
        var available_times_url = $("#organization_contact_filter-wrap").data("available-times-url");

        if (!$("#id_request_date").val() || !$("#organization_contact_filter").val()) {
            disable_time_field();

            return;
        }

        var jqxhr = $.ajax({
            method: "GET",
            url: available_times_url,
            data: {
                query: $("#id_request_date").val(),
                f_att: $("#organization_contact_filter").val()
            }
        }).done(function(data) {
            // console.log("success");
            // console.log(data);
            if (data.suggestions && data.suggestions.length > 0) {
                $("#id_request_time").html("").show();
                for (var i in data.suggestions) {
                    var sug = data.suggestions[i];
                    $("#id_request_time").append($('<option />').val(sug.value).text(sug.data));
                }

                if ($("#id_request_time").val() != "") {
                    $submit_form.prop('disabled', false);
                }

                $("#id_request_time").prop('disabled', false);
            } else {
                // TODO: i18n
                // TODO: Pensar que hacemos aqui...
                alert('No hay horas disponibles para ese contacto en esa fecha');
                $("#id_request_time").hide();
                $submit_form.prop('disabled', true);
            }
        }).fail(function() {
            // TODO: i18n
            // TODO: Pensar que hacemos aqui...
            alert("Error al intentar recuperar las horas disponibles");
            $("#id_request_time").hide();
            $submit_form.prop('disabled', true);
        }).always(function() {
            // console.log("complete");
        });
    }

    function populate_available_dates() {
        var available_dates_url = $("#organization_contact_filter-wrap").data("available-dates-url");

        if (!$("#organization_contact_filter").val()) {
            disable_date_field()
            return;
        }

        var jqxhr = $.ajax({
            method: "GET",
            url: available_dates_url,
            data: { query: $("#organization_contact_filter").val() }
        }).done(function(data) {
            // console.log("success");
            // console.log(data);
            if (data.suggestions && data.suggestions.length > 0) {
                $("#id_request_date").html("").show();
                for (var i in data.suggestions) {
                    var sug = data.suggestions[i];
                    $("#id_request_date").append($('<option />').val(sug.value).text(sug.data));
                }

                $("#id_request_date").off("change").on("change", function () {
                    populate_available_times();
                });

                $("#id_request_date").prop('disabled', false);

                populate_available_times();
            } else {
                // TODO: i18n
                // TODO: Pensar que hacemos aqui...
                alert($("#query-organization_contact_filter").val() + ' no tiene huecos disponibles. Intentelo de nuevo mas tarde o pruebe con otro contacto.');
                $("#id_request_date").hide();
                $("#id_request_time").hide();
                $submit_form.prop('disabled', true);
                $("#organization_contact_filter-wrap .clear-autocomplete").focus();
            }
        }).fail(function() {
            // TODO: i18n
            // TODO: Pensar que hacemos aqui...
            alert("Error al intentar recuperar las fechas disponibles");
            $("#id_request_date").hide();
            $submit_form.prop('disabled', true);
        }).always(function() {
            // console.log("complete");
        });
    }

    function get_a10e_fields(input_id) {
        var $wrap_widget = $("#" + input_id + "-wrap");

        return {
            'wrap_widget': $wrap_widget,
            'data_input': $("#" + input_id),
            'query_input': $("#query-" + input_id),
            'clear_button': $wrap_widget.find(".clear-autocomplete")
        };
    }

    function init_autocomplete(input_id, on_select_callback, on_clear_callback) {
        $("#" + input_id + "-wrap").each(function () {
            // aunque input_id y $(this).data("id") son lo mismo
            // nos conviene usar el campo data-id por si movemos el codigo a otro lado
            var $fields = get_a10e_fields($(this).data("id"));

            var $wrap_widget = $fields["wrap_widget"];
            var $data_input = $fields["data_input"];
            var $query_input = $fields["query_input"];
            var $clear_button = $fields["clear_button"];

            var i = 1;
            var extra_params = {};

            while ($wrap_widget.data("get-arg-" + i)) {
                extra_params[$wrap_widget.data("get-arg-" + i)] = $wrap_widget.data("get-inp-" + i);
                i++;
            }

            $query_input.autocomplete({
                minChars: 0,
                serviceUrl: $wrap_widget.data("url"),
                extra_params: extra_params,
                noCache: true,
                onSelect: function (suggestion) {
                    $data_input.val(suggestion.data);
                    $query_input.prop('readonly', true);
                    $clear_button.prop('disabled', false);

                    if (on_select_callback) {
                        on_select_callback({
                            "input_id": $wrap_widget.data("id"),
                            "suggestion": suggestion
                        });
                    }
                }
            });

            $clear_button.on("click", function () {
                $(".alert.alert-danger.field-errors").remove();
                $data_input.val("");
                $query_input.val("");
                $query_input.prop('readonly', false);
                $clear_button.prop('disabled', true);

                if (on_clear_callback) {
                    on_clear_callback($wrap_widget);
                }
            });
        });
    }
}
